export const colors = {
    blue800: '#214466',
    blue400: '#4184B1',
    blue100: '#DEEBFF',
    linkBlue: '0D6EFD',
    black: 'black',
    green: '#58CF6B',
    red: 'red',
    blue: '#2684ff',
    grey: '#959595',
    grey200: '#F6F8FC',
    grey800: '#C4C4C4',
    white: '#ffffff'
}